import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api, { money, fmtDate } from "@/mechanic/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function DealershipCars() {
  const navigate = useNavigate();
  const { data: cars = [], isLoading } = useQuery({ queryKey: ["mech-dealer"], queryFn: async () => (await api.get("/dealership-cars")).data });

  return (
    <div className="p-8" data-testid="mech-dealer-page">
      <h1 className="font-heading text-3xl mb-1">Dealership Cars</h1>
      <p className="text-muted-foreground mb-6">Service & repair history for cars in your dealership inventory. Cars sync automatically as you buy/sell.</p>

      <Card className="overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Vehicle</TableHead>
              <TableHead>Stock #</TableHead>
              <TableHead>Inventory Status</TableHead>
              <TableHead className="text-right">Repairs</TableHead>
              <TableHead>Last Service</TableHead>
              <TableHead className="text-right">Total Spent</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {isLoading ? (
              <TableRow><TableCell colSpan={6} className="text-center py-10 text-muted-foreground">Loading…</TableCell></TableRow>
            ) : cars.length === 0 ? (
              <TableRow><TableCell colSpan={6} className="text-center py-10 text-muted-foreground">No dealership cars. Add inventory in the Dealership module.</TableCell></TableRow>
            ) : cars.map((c) => (
              <TableRow key={c.id} className="cursor-pointer" data-testid={`dealer-car-row-${c.id}`} onClick={() => navigate(`/mechanic/vehicle/dealership/${c.id}`)}>
                <TableCell className="font-semibold">{c.label}</TableCell>
                <TableCell className="font-mono-data text-xs">{c.stock_number || "—"}</TableCell>
                <TableCell><Badge className="border-0 bg-secondary text-foreground">{c.status}</Badge></TableCell>
                <TableCell className="text-right">{c.work_order_count}</TableCell>
                <TableCell>{fmtDate(c.last_service_date)}</TableCell>
                <TableCell className="text-right font-mono-data">{money(c.total_spent)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
